export enum ROLES {
  MANAGER = "Manager",
  WAITER = "Waiter",
  SUPERADMIN = "SuperAdmin",
}

/**
 * The {@link ROLES} value for a role name in any casing, or undefined when it is not a role. The API serialises enums
 * in camelCase (`superAdmin`), while the Firebase claim and {@link ROLES} use PascalCase (`SuperAdmin`).
 */
export const toRole = (role: string | null | undefined): ROLES | undefined =>
  Object.values(ROLES).find((value) => value.toLowerCase() === role?.toLowerCase());

export const ROLES_LEVELS = {
  [ROLES.SUPERADMIN]: 0,
  [ROLES.MANAGER]: 1,
  [ROLES.WAITER]: 2,
};

